export const getMusicRecordsRoute = () => '/records';
export const getMusicRecordCreateRoute = () => '/records/create';
export const getMusicRecordLyricsRoute = (recordId = null) => '/records/' + (recordId ?? ':recordId') + '/lyrics';
export const getMusicRecordEditRoute = (recordId = null) => '/records/' + (recordId ?? ':recordId');
